/**
 * obfuscate disallowed properties from log events.
 */
const _ = require('lodash');
const disallowed = require('./disallowed');

const obfuscateLog = (objParam, prop) => {
  const obj = objParam;
  if (disallowed.some(value => new RegExp(`^${value}$`, 'i').test(prop))) {
    if (!_.isNull(obj[prop])) {
      obj[prop] = '******';
    }
  }
};

const obfuscateProps = obj => {
  const objectToModify = _.cloneDeep(obj);
  Object.keys(objectToModify).forEach(prop => {
    obfuscateLog(objectToModify, prop);
  });
  return objectToModify;
};

module.exports = { obfuscateProps, obfuscateLog };
